import { Search as Lunr } from '@/lib/lunr';
import { squishies } from '@/squishy.data';
import { RARITY, RARITY_TO_NAME, SQUISHY_ID } from '@/constants';
import {
  useCallback,
  useState,
  useMemo,
  type ChangeEvent,
} from 'react';

export type Doc = {
  id: SQUISHY_ID;
  name: string;
  rarity: string;
};

const docs = squishies
  .filter(squishy => squishy.rarity !== RARITY.LOCKED)
  .sort((a, b) => {
    if (a.rarity !== b.rarity) {
      return a.rarity - b.rarity;
    }
    return a.name.localeCompare(b.name);
  })
  .map(squishy => ({
    id: squishy.id,
    name: squishy.name,
    rarity: RARITY_TO_NAME.get(squishy.rarity),
  })) as Doc[]

export const useSearch = () => {
  const [value, setValue] = useState('');
  const [results, setResults] = useState<Doc[]>([])
  const index = useMemo(() => {
    const index = Lunr('id');
    
    index.addIndex('name');

    index.addDocuments([...docs]);

    return index;
  }, []);

  const onValueChange = useCallback((value: string) => {
    if (!value.length) {
      setValue('');
      setResults([]);
      return;
    }

    setValue(value);
    setResults(index.search(value));
  }, []);
  
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onValueChange(e.target.value.trim());
  }, []);

  return {
    value,
    onChange,
    results: !value.length ? docs : results,
  };
};